import React, {useRef} from "react";

interface TooltipVideoContainerProps {
  children: React.ReactNode;
  bottomPosition: string;
}

const TOOLTIP_TOP = "unset";
const TOOLTIP_MARGIN_TOP = "0";
const VIDEO_TOOLIP_CLASS = ".ql-editing";

export const TooltipVideoContainer: React.FC<TooltipVideoContainerProps> = ({
  children,
  bottomPosition,
}): JSX.Element => {
  const richTextEditorContainer = useRef<HTMLDivElement>(null);
  const scrollPrevent = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };
  const onClickInterseptor = () => {
    if (richTextEditorContainer.current) {
      const el = richTextEditorContainer.current.querySelector<HTMLElement>(
        VIDEO_TOOLIP_CLASS
      );
      if (el) {
        el.style.top = TOOLTIP_TOP;
        el.style.bottom = bottomPosition;
        el.style.marginTop = TOOLTIP_MARGIN_TOP;
      }
    }
  };
  return (
    <div
      ref={richTextEditorContainer}
      role="presentation"
      onClick={onClickInterseptor}
      onScroll={scrollPrevent}
    >
      {children}
    </div>
  );
};
